/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";

function SanayiTipiYagCozucu() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
{
"picture": "assets/images/20-kg/1.webp",
"nav": "/kireccozucu",
"title": "Kireç Çözücü"
},
{
"picture": "assets/images/20-kg/2.webp",
"nav": "/camasirsuyu",
"title": "Çamaşır Suyu"
},
{
"picture": "assets/images/20-kg/3.webp",
"nav": "/ultrakivamlicamasirsuyu",
"title": "Ultra Kıvamlı Ç. Suyu"
},
{
"picture": "assets/images/20-kg/4.webp",
"nav": "/sanayitipiyagcozucu",
"title": "Sanayi Tipi Yağ Sökücü"
},
{
"picture": "assets/images/20-kg/5.webp",
"nav": "/bulasikdeterjaniluks",
"title": "Bulaşık DeterjanI Lüx"
},
{
"picture": "assets/images/20-kg/6.webp",
"nav": "/bulasikmakina",
"title": "B. Makina Deterjanı"
},
{
"picture": "assets/images/20-kg/7.webp",
"nav": "/bulasikmakinaparlaticisi",
"title": "B. Makina Parlatıcısı"
},
{
"picture": "assets/images/20-kg/8.webp",
"nav": "/wcbanyotemizleyici",
"title": "Wc Banyo Temizleyici"
},
{
"picture": "assets/images/20-kg/9.webp",
"nav": "/bulasikdeterjaniekstra",
"title": "B. Deterjanı Ekstra"
},
{
"picture": "assets/images/20-kg/10.webp",
"nav": "/yuzeytemizlikmaddesi",
"title": "Yüzey Temizlik Maddesi"
},
{
"picture": "assets/images/20-kg/11.webp",
"nav": "/sivielsabunumavi",
"title": "Sıvı El Sabunu (Mavi)"
},
{
"picture": "assets/images/20-kg/12.webp",
"nav": "/sivielkopuk",
"title": "Sıvı El Köpük"
},
{
"picture": "assets/images/20-kg/13.webp",
"nav": "/bulasikmakinapro",
"title": "B. Makina Deterjanı Pro"
},
{
"picture": "assets/images/20-kg/14.webp",
"nav": "/bulasikmakinaparlaticisipro",
"title": "B. Makina Parlatıcısı Pro"
},
{
"picture": "assets/images/20-kg/15.webp",
"nav": "/sivielsabunu",
"title": "Sıvı El Sabunu"
}

]

return (
<>
  <SRLWrapper>
    <section class="product-details section-space">
      <div class="container">
        <div class="row gutter-y-50">
          <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
            <div class="product-details__img">
              <div class="swiper product-details__gallery-top p-5">
                <div className="album-list-item">
                  <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                  <div className="ali-img-wrap">
                    <div>
                      <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/4.webp" alt="image"
                        title="image" />
                    </div>
                  </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
            <div class="product-details__content">
              <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <ProductTitleVideo title="Sanayi Tipi Yağ Çözücü" video="" />
                <span className="product-details__weight"
                  style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                  5 KG - 20 KG
                </span>
              </div>
              <div class="product-details__excerpt">
                <h4 class="mt-4 mb-3">ÖZELLİKLERİ</h4>
                <ul class="product-details__list">
                  <li>Özellikle mutfaklardaki zeminler, davlumbazlar, duvarlar üzerinde yoğunlaşan yağ tabakasının ve
                    yoğun kirin temizlenmesinde etkilidir.</li>
                  <li>Konsantre olduğu için sulandırılarak kullanılırve ekonomiktir. Manuel olarak yada zeminlerde makine ile
                    uygulanabilir. Çağdaş yüzey aktif maddeler doğada parçalanabilir.</li>
                  <li>Alüminyum yüzeylerde kontrollü olarak kullanılabilir. Profesyonel kullanım içindir.</li>
                </ul>

                <h4 class="mt-4 mb-3">ÜRÜN BİLEŞİMİ</h4>
                <p class="product-details__description__text">
                  Aktif madde, alkaliler, fosfatlar ve solvent içerir.
                </p>
              </div>

              <div class="product-details__buttons">
                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__text">
                  {" "}
                  DİĞER ÜRÜNLERİMİZ
                </span>
                <i class="icon-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-details__description-wrapper">
        <div class="container">
          <div class="product-details__description">
            <h3 class="product-details__description__title">
              Ürün Detayları
            </h3>
            <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

              <h4 class="mt-4 mb-3">KULLANMA TALİMATI</h4>
              <p class="product-details__description__text">
                Dexpur Davlumbaz Yağ Çözücü, "mutfak ekipmanlarında püskürtülerek direk uygulanabilir. Zeminlerde ıslak mop
                veya yer yıkama makinesi ile yüzey üzerine yayılır,
                yüzeyi aynı makine ile fırçalayıp, zemindeki solüsyon vakumlanır. Gerekirse zemin üzerinde 10-20 dk
                bekledikten sonra vakumlama işlemi yapılır.
              </p>

              <div class="alert alert-info mt-4 p-4 text-white" style={{ backgroundColor: "#10adad" }}>
                <h6><strong>TÜKETİCİNİN DİKKATİNE:</strong></h6>
                <ul class="mb-0">
                  <li>Ciddi yanıklara neden olur. Aerosollerini solumayınız.</li>
                  <li>Göz ile temasında hemen bol su ile yıkayınız ve doktora başvurunuz.</li>
                  <li>Cilt ile temasında hemen bol su ile yıkayınız.</li>
                  <li>Çalışırken uygun koruyucu kıyafet, eldiven ve göz/yüz koruyucu kullanınız.</li>
                  <li>Kaza halinde veya kendinizi iyi hissetmiyorsanız ürün etiketi ile birlikte hemen doktora
                    başvurunuz.</li>
                  <li>Yalnızca iyi havalandırılan yerlerde kullanınız.</li>
                  <li>Kullanma talimatını mutlaka okuyunuz.</li>
                  <li>Kapakta bulunan emniyet pimi kırılmış bidonları satın almayınız.</li>
                  <li>Çocuklardan ve gıda maddelerinden uzak tutunuz.</li>
                  <li>El, yüz, vücut ve gıda temizliğinde kullanmayınız.</li>
                  <li>Dexpur, yanlış kullanım ve saklamadan doğacak zarardan sorumlu değildir.</li>
                </ul>
              </div>

              <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                <h6><strong>⚠️ ZEHİRLENME DURUMUNDA ACİL NUMARALAR :</strong></h6>
                <div class="alert alert-light mt-3 mb-3 text-dark">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-1"><strong>114</strong></p>
                      <p class="mb-0 small">ULUSAL ZEHİR DANIŞMA MERKEZİ</p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-1"><strong>112</strong></p>
                      <p class="mb-0 small">ACİL SAĞLIK HİZMETLERİ</p>
                    </div>
                  </div>
                </div>

                <div class="alert alert-warning mt-3 mb-0">
                  <p class="mb-0">
                    <strong>⚠️ DİKKAT:</strong> Üretim tarihi, son kullanma tarihi ile parti no ve seri no, ambalajın
                    üzerindedir.
                  </p>
                </div>
              </div>

              <div class="product-info-box mt-4 p-3 bg-light">
                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                <div class="row">
                  <p><strong>Net Ağırlık:</strong> 5 KG ve 20 KG Seçenekleri mevcuttur.</p>
                  <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </SRLWrapper>
</>
);
}

export default SanayiTipiYagCozucu;